export const baseurl = 'https://api.profiling.star-horizon.com/';
//export const baseurl = 'http://localhost:8000/';
